export const DisclaimerAdExtension = {
  properties: {
    'bulk-upload-type': {
      type: 'string',
      value: 'DisclaimerAdExtension',
    },
  },
};
